import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import ImageUploadField from 'components/organisms/ImageUpload/ImageUploadField'

import { FORM_ACTION_ERROR_STATUS } from 'constants/form'

export const styles = theme => ({
  root: {},
  header: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  createdDate: {
    color: theme.palette.disabled.main,
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  nameControl: {
    width: '50%',
  },
  uploadLogoTitle: {
    fontSize: 14,
    textAlign: 'left',
    marginTop: theme.spacing(2),
    textTransform: 'uppercase',
  },
  imageUpload: {
    margin: `${theme.spacing(2)}px 0 ${theme.spacing(4)}px 0`,
  },
})

const EditOrganisationForm = ({
  dirty,
  errors,
  status,
  values,
  classes,
  createdDate,
  isSubmitting,
  errorMessage,
  hasFieldError,
  handleFormSubmit,
  handleFieldChange,
  handleImageChange,
  handleImageRemoved,
  className: classNameProp,
}) => {
  const className = classNames(classes.root, classNameProp)
  return (
    <div className={className}>
      {status === FORM_ACTION_ERROR_STATUS && errorMessage ? (
        <Typography
          color="error"
          align="center"
          className={classes.errorMessage}>
          {errorMessage}
        </Typography>
      ) : null}
      <form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
        <div className={classNames(classes.header)}>
          <Typography className={classes.createdDate}>
            Project created {createdDate}
          </Typography>
          <SubmitButton
            autoFocus
            size="medium"
            type="submit"
            color="primary"
            variant="primary"
            showLoader={isSubmitting}
            disabled={isSubmitting || !dirty}>
            Update
          </SubmitButton>
        </div>
        <FormControl
          className={classNames(classes.formControl, classes.nameControl)}
          fullWidth
          error={hasFieldError('name')}>
          <TextField
            name="name"
            type="name"
            id="name-input"
            margin="normal"
            inputProps={{
              maxLength: 1024,
            }}
            value={values.name}
            autoComplete="name"
            label="Project name"
            onChange={handleFieldChange}
            error={hasFieldError('name')}
          />
          {hasFieldError('name') ? (
            <FormHelperText>{errors.name}</FormHelperText>
          ) : null}
        </FormControl>
          {/*
        <Typography className={classes.uploadLogoTitle} variant="h3">
          Upload project logo
        </Typography>
        <FormControl
          className={classNames(classes.formControl, classes.imageUpload)}
          fullWidth
          error={hasFieldError('image')}>
          <ImageUploadField
            name="image"
            error={errors.image}
            helperText="240px by 180px works best"
            onSelect={handleImageChange}
            onRemove={handleImageRemoved}
          />
          {hasFieldError('image') ? (
            <FormHelperText error>{errors.image}</FormHelperText>
          ) : null}
        </FormControl>
        */}
      </form>
    </div>
  )
}

EditOrganisationForm.propTypes = {
  dirty: PropTypes.bool,
  errors: PropTypes.object,
  status: PropTypes.string,
  values: PropTypes.object,
  className: PropTypes.string,
  apiCallError: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  createdDate: PropTypes.string,
  hasFieldError: PropTypes.func,
  errorMessage: PropTypes.string,
  handleFormSubmit: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleImageChange: PropTypes.func,
  handleImageRemoved: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleCheckboxChange: PropTypes.func,
}

export default withStyles(styles)(EditOrganisationForm)



// WEBPACK FOOTER //
// ./src/components/organisms/EditOrganisationForm/EditOrganisationForm.js